import { render, staticRenderFns } from "./departmentStatus.vue?vue&type=template&id=0c050008&"
import script from "./departmentStatus.vue?vue&type=script&lang=js&"
export * from "./departmentStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports